module.exports = "/images/chen-hui.jpg?f24ee1095851c8db4d8e2f439732ee94";